// Exponential backoff alone makes every client retry on the same schedule —
// harmless with one client, but a growing fleet all hitting the backend at
// the same instant is what turns a transient blip into a load spike. Full
// jitter (0.5x-1x of the exponential value) spreads retries across a window
// instead of a point in time.
export function jitteredBackoffDelay(attempt: number, maxDelayMs: number) {
  const exponential = Math.min(1000 * 2 ** attempt, maxDelayMs)
  return exponential * (0.5 + Math.random() * 0.5)
}
